import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=125d4910"
import script from "./PhoneInput.vue?vue&type=script&lang=ts"
export * from "./PhoneInput.vue?vue&type=script&lang=ts"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=125d4910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports